import React from 'react';
import PT from 'prop-types';

const DirectionIndicatorSVG = ({ direction = 'next' }) => {
  if (direction === 'prev') {
    return (
      <svg width="28" height="8" viewBox="0 0 28 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="8" height="8" rx="4" fill="#C0C7CE" />
        <rect x="12" width="16" height="8" rx="4" fill="#969FA8" />
      </svg>

    );
  }

  return (
    <svg width="28" height="8" viewBox="0 0 28 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="8" rx="4" fill="#969FA8" />
      <rect x="20" width="8" height="8" rx="4" fill="#C0C7CE" />
    </svg>
  );
};

DirectionIndicatorSVG.propTypes = {
  direction: PT.oneOf(['next', 'prev']),
};

export default DirectionIndicatorSVG;
